import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  date?: string;
}
export const TestimonialCard = ({
  quote,
  author,
  date = 'Verified Customer'
}: TestimonialCardProps) => {
  return <div className="bg-white rounded-lg shadow-lg mb-6 overflow-hidden" data-id="element-315">
      <div className="bg-[#00b67a] px-4 py-2 flex items-center" data-id="element-316">
        <div className="flex items-center" data-id="element-317">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-white text-white" data-id="element-318" />)}
        </div>
      </div>
      <div className="p-6" data-id="element-319">
        <blockquote className="text-gray-800 text-lg mb-4" data-id="element-320">{quote}</blockquote>
        <div className="flex items-center justify-between text-sm" data-id="element-321">
          <p className="font-medium text-gray-700" data-id="element-322">{author}</p>
          <p className="text-gray-500" data-id="element-323">{date}</p>
        </div>
      </div>
      <div className="px-6 py-2 bg-gray-50 flex items-center justify-between" data-id="element-324">
        <div className="flex items-center" data-id="element-325">
          <svg className="w-4 h-4 text-[#00b67a] mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-id="element-326">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" data-id="element-327" />
          </svg>
          <span className="text-[#00b67a] font-medium" data-id="element-328">Trustpilot</span>
        </div>
        <span className="text-xs text-gray-500" data-id="element-329">Posted on Trustpilot</span>
      </div>
    </div>;
};